// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ScheduleFilledSvg from "@ant-design/icons-svg/es/asn/ScheduleFilled";
import AntdIcon from '../components/AntdIcon';

var ScheduleFilled = function ScheduleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ScheduleFilledSvg
  }));
};

ScheduleFilled.displayName = 'ScheduleFilled';
export default /*#__PURE__*/React.forwardRef(ScheduleFilled);